export function isCancelledStatus(status) {
  return String(status || '').toLowerCase() === 'cancelled'
}

export function filterCancelledSessions(sessions) {
  if (!Array.isArray(sessions)) return []
  return sessions.filter((session) => !isCancelledStatus(session?.status))
}

export function filterCancelledRosterEntries(entries) {
  if (!Array.isArray(entries)) return []
  return entries.filter((entry) => !isCancelledStatus(entry?.status))
}
